/**
 * Constants for published swimlane views
 *
 * Only extracted where it adds genuine value:
 * - Used in multiple places (DRY)
 * - Configuration that might change
 * - Domain-specific terms needing consistency
 */

// Swimlane display limits
export const SWIMLANE_LIMITS = {
  maxCardTitleLines: 3,
  rowHeadersWidth: 180,
  maxSelectedCards: 100,
  maxSubItemsPerItem: 20,
} as const;
